import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import MarkField from './MarkField'
import ChevronDownIcon from '../ui/icons/ChevronDownIcon'

const HEADER_CLASS = [
  'tw:flex tw:items-center tw:gap-2 tw:bg-white tw:border tw:border-gray-300 tw:p-3',
  'tw:text-sm tw:font-medium tw:text-gray-900'
].join(' ')
const BODY_CLASS = 'tw:rounded-b-lg! tw:bg-gray-50 tw:border-x tw:border-b tw:border-gray-300 '
  + 'tw:p-4 tw:flex tw:flex-col tw:gap-4'
const TOGGLE_CLASS = 'tw:flex tw:items-center tw:gap-1 tw:border-0 tw:bg-transparent tw:cursor-pointer '
  + 'tw:text-sm tw:font-normal tw:text-gray-700'

const SectionBlock = ({
  parallel, readonly, collapsible, collapsed, errors, hidden, onMarkChange, onToggle
}) => {
  const handleToggle = useCallback(() => onToggle(parallel.id), [onToggle, parallel.id])

  const headerRadius = collapsed ? 'tw:rounded-lg!' : 'tw:rounded-t-lg!'
  const chevronClass = `tw:text-xl tw:leading-none ${collapsed ? '' : 'tw:rotate-180'}`.trim()

  return (
    <div className="tw:mb-6">
      <div className={`${HEADER_CLASS} ${headerRadius}`}>
        <span className="tw:flex-1 tw:min-w-0">{parallel.section.name}</span>
        {collapsible ? (
          <button className={TOGGLE_CLASS} type="button" onClick={handleToggle}>
            {collapsed ? 'Déplier' : 'Replier'}
            <span className={chevronClass}>
              <ChevronDownIcon />
            </span>
          </button>
        ) : null}
      </div>
      {collapsed ? null : (
        <div className={BODY_CLASS}>
          {parallel.marks.filter(mark => !hidden[mark.question.id]).map((mark, index) => (
            <MarkField
              key={mark.id}
              errors={errors[`marks[${mark.id}]`]}
              first={index === 0}
              mark={mark}
              readonly={readonly}
              onChange={onMarkChange}
            />
          ))}
        </div>
      )}
    </div>
  )
}

SectionBlock.propTypes = {
  collapsed: PropTypes.bool,
  collapsible: PropTypes.bool,
  errors: PropTypes.objectOf(PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string))),
  hidden: PropTypes.objectOf(PropTypes.bool),
  onMarkChange: PropTypes.func.isRequired,
  onToggle: PropTypes.func,
  parallel: PropTypes.shape({
    id: PropTypes.number.isRequired,
    marks: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired })).isRequired,
    section: PropTypes.shape({ name: PropTypes.string }).isRequired
  }).isRequired,
  readonly: PropTypes.bool
}

SectionBlock.defaultProps = {
  collapsed: false,
  collapsible: false,
  errors: {},
  hidden: {},
  onToggle: () => null,
  readonly: false
}

export default SectionBlock
